export default "__VITE_ASSET__0vsbpL8o__"